import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ClientServicePropositionDispatcher } from "./Variable";

export interface IClientServicePropositionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: {
        servicePropositionId: number;
        clAccountId: string;
    };
}

export class ClientServicePropositionStatic extends BaseStore<IClientServicePropositionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ClientServicePropositionDispatcher, (actionData) =>
            this.onClientServicePropositionStoreResponse(actionData)
        );
    }

    public getLastResult(): IClientServicePropositionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): IClientServicePropositionStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onClientServicePropositionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
